import React from 'react'
import './CharteAchatsDurables.css';

const CharteAchatsDurables: React.FC = () => {
    return (
        <div className="charte-achats-page">
            <div className="charte-achats-container">
                <h1 className="charte-achats-title-h1">Charte des Achats Durables de Centralis</h1>
                <h2 className="charte-achats-title-h2">Mise à jour le 17 juin 2025</h2>

                <h3 className="charte-achats-title-h3">Préambule</h3>
                <p className="charte-achats-paragraph">
                    L’association Centralis, centrale d’achat mutualisée dédiée à la rénovation du patrimoine des acheteurs publics,
                    affirme sa volonté de promouvoir une commande publique exemplaire sur les plans économique, social et environnemental.
                    En cohérence avec les principes de la commande publique durable et les objectifs de transition écologique,
                    Centralis adopte la présente charte des achats durables.
                </p>
                <p className="charte-achats-paragraph">
                    Elle s’adresse à l’ensemble des parties prenantes de l’écosystème de Centralis :
                    membres acheteurs, entreprises titulaires, partenaires publics, salariés, prestataires et bénévoles.
                </p>

                <h3 className="charte-achats-title-h3">1. Garantir une commande publique économiquement efficace</h3>
                <h4 className="charte-achats-title-h4">Faciliter l’accès à la commande publique</h4>
                <ul className="charte-achats-ul">
                    <li>Encourager la participation des TPE, PME, artisans et structures locales par une politique d’allotissement systématique ou justifiée.</li>
                    <li>Mettre à disposition des outils simplifiés : DUME, cadres de réponse, catalogue électronique.</li>
                    <li>Ne demander que les pièces strictement nécessaires à l’analyse des offres.</li>
                    <li>Favoriser la sobriété numérique et appliquer le principe "Dites-le nous une fois".</li>
                </ul>

                <h4 className="charte-achats-title-h4">Optimiser la dépense publique</h4>
                <ul className="charte-achats-ul">
                    <li>Programmer les achats sur plusieurs années, en lien avec les besoins récurrents des membres.</li>
                    <li>Mettre en œuvre la stratégie de mutualisation et de groupement d’achat.</li>
                    <li>Évaluer les offres sur le coût global d’usage, incluant maintenance, consommation et durée de vie.</li>
                    <li>Favoriser les achats réversibles, évolutifs, adaptables.</li>
                </ul>

                <h4 className="charte-achats-title-h4">Garantir une relation fournisseur équilibrée</h4>
                <ul className="charte-achats-ul">
                    <li>Respecter les délais de paiement.</li>
                    <li>Veiller à la bonne application des clauses de révision de prix.</li>
                    <li>Faciliter les demandes d’acomptes ou d’avances lorsque les conditions sont remplies.</li>
                    <li>Protéger les droits des sous-traitants (paiement direct, recours en cas de litige).</li>
                    <li>Prévoir des clauses de réexamen adaptées en cas de modification du besoin ou du contexte économique.</li>
                </ul>

                <h3 className="charte-achats-title-h3">2. Promouvoir une commande publique socialement équitable</h3>
                <h4 className="charte-achats-title-h4">Favoriser l’insertion et l’emploi local</h4>
                <ul className="charte-achats-ul">
                    <li>Intégrer des clauses sociales pertinentes dans les marchés, en collaboration avec les facilitateurs locaux (insertion, apprentissage, formation).</li>
                    <li>Encourager les groupements incluant des acteurs de l’économie sociale et solidaire (ESS).</li>
                </ul>

                <h4 className="charte-achats-title-h4">Lutter contre les discriminations</h4>
                <ul className="charte-achats-ul">
                    <li>Assurer l’égalité d’accès à la commande publique pour tous les opérateurs, quelle que soit leur taille ou origine géographique.</li>
                    <li>Intégrer l’accessibilité universelle dans les spécifications des marchés.</li>
                    <li>Promouvoir la diversité, l’égalité femmes-hommes, et la lutte contre le travail illégal ou dissimulé.</li>
                </ul>

                <h4 className="charte-achats-title-h4">Veiller à des conditions de travail décentes</h4>
                <ul className="charte-achats-ul">
                    <li>Exiger des titulaires qu’ils respectent les droits sociaux fondamentaux, le droit du travail et la réglementation relative au détachement.</li>
                    <li>Mettre en œuvre un contrôle du respect des obligations sociales des entreprises titulaires et de leurs sous-traitants.</li>
                </ul>

                <h3 className="charte-achats-title-h3">3. Atteindre une commande publique écologiquement soutenable</h3>
                <h4 className="charte-achats-title-h4">Réduire l’empreinte environnementale des achats</h4>
                <ul className="charte-achats-ul">
                    <li>Intégrer systématiquement un critère de performance environnementale dans les consultations.</li>
                    <li>Favoriser les produits éco-labellisés, recyclés, reconditionnés ou à haute réparabilité.</li>
                    <li>Exiger des livraisons groupées, à faible émission carbone, et promouvoir le conditionnement sobre.</li>
                </ul>

                <h4 className="charte-achats-title-h4">Intégrer l’économie circulaire</h4>
                <ul className="charte-achats-ul">
                    <li>Prévoir des prestations de réemploi, de valorisation des déchets, et de traitement des matériaux issus des chantiers.</li>
                    <li>Encourager les démarches "zéro déchet", notamment pour les prestations événementielles.</li>
                    <li>Valoriser les équipements réformés par le don ou la vente.</li>
                </ul>

                <h4 className="charte-achats-title-h4">Promouvoir la sobriété numérique</h4>
                <ul className="charte-achats-ul">
                    <li>Privilégier les solutions numériques légères et pérennes.</li>
                    <li>Encourager l’éco-conception des outils numériques utilisés par Centralis et ses prestataires.</li>
                </ul>

                <h3 className="charte-achats-title-h3">4. Développer une culture commune de l’achat responsable</h3>
                <h4 className="charte-achats-title-h4">Former et accompagner les parties prenantes</h4>
                <ul className="charte-achats-ul">
                    <li>Former les agents, membres et bénévoles à l’achat durable.</li>
                    <li>Intégrer une charte de déontologie dans toutes les procédures d’achats.</li>
                    <li>Mettre en place une évaluation des fournisseurs et un retour d’expérience à chaque marché.</li>
                </ul>

                <h4 className="charte-achats-title-h4">Impliquer les acteurs économiques</h4>
                <ul className="charte-achats-ul">
                    <li>Organiser régulièrement des sessions de sourcing et des échanges avec les entreprises locales et engagées.</li>
                    <li>Communiquer en amont sur la programmation des marchés.</li>
                    <li>Promouvoir l’innovation responsable dans les réponses aux marchés.</li>
                </ul>

                <h3 className="charte-achats-title-h3">5. Mise en œuvre et suivi de la charte</h3>
                <p className="charte-achats-paragraph">
                    Centralis s’engage à :
                </p>
                <ul className="charte-achats-ul">
                    <li>Suivre l’application de la présente charte par ses membres et ses partenaires.</li>
                    <li>Évaluer périodiquement les résultats et ajuster les pratiques.</li>
                    <li>Publier un rapport annuel de performance achat durable.</li>
                    <li>Associer ses parties prenantes au suivi de la démarche (Conseil de Surveillance, comité technique, commission achats, représentants des prestataires).</li>
                </ul>

                <h3 className="charte-achats-title-h3">Conclusion</h3>
                <p className="charte-achats-paragraph">
                    Par cette charte, Centralis affirme son ambition d’être un acteur exemplaire et engagé de la commande publique responsable.
                    Chaque membre, agent, fournisseur ou partenaire est invité à contribuer à la mise en œuvre de ces principes
                    au service d’une commande publique plus juste, plus verte et plus efficiente.
                </p>
            </div>
        </div>
    )
}

export default CharteAchatsDurables;